import React from 'react';
import { Refine, Authenticated } from '@refinedev/core';
import { Typography } from 'antd';
import { YachtIcon } from './components/icons/YachtIcon';
import type { I18nProvider } from '@refinedev/core';
import { RefineKbarProvider } from '@refinedev/kbar';
import { useTranslation } from 'react-i18next';
import { dataProvider, liveProvider } from '@refinedev/supabase';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { notificationProvider, ThemedLayoutV2 } from '@refinedev/antd';
import '@refinedev/antd/dist/reset.css';
import { Login } from './pages/login';

import { supabaseClient } from './config/supabase';
import { authProvider } from './auth/provider';
import { themeConfig } from './config/theme';
import { resources } from './config/resources';
import { MainLayout } from './components/core/layout/MainLayout';
import { RaceList } from './pages/races/list';
import { RaceCreate } from './pages/races/create';
import { RaceEdit } from './pages/races/edit';
import { RaceShow } from './pages/races/show';
import './i18n';

const App: React.FC = () => {
  const { t, i18n } = useTranslation();

  const i18nProvider: I18nProvider = {
    translate: (key: string | string[], params?: Record<string, unknown>) => t(key, params),
    changeLocale: (lang: string) => i18n.changeLanguage(lang),
    getLocale: () => i18n.language,
  };

  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <RefineKbarProvider>
        <ConfigProvider theme={themeConfig}>
          <Refine
            dataProvider={dataProvider(supabaseClient)}
            liveProvider={liveProvider(supabaseClient)}
            authProvider={authProvider}
            notificationProvider={notificationProvider}
            resources={resources}
            i18nProvider={i18nProvider}
            options={{
              syncWithLocation: true,
              warnWhenUnsavedChanges: true,
              reactQuery: {
                devtoolConfig: false,
              },
            }}
          >
            <Routes>
              <Route
                element={
                  <Authenticated key="auth-check" fallback={<Login />}>
                    <ThemedLayoutV2
                      Title={() => {
                        return (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <YachtIcon size={24} />
                            <Typography.Title level={4} style={{ margin: 0, whiteSpace: 'nowrap', marginLeft: '12px' }}>
                              KYCレース・申込データ管理
                            </Typography.Title>
                          </div>
                        );
                      }}
                    >
                      <MainLayout>
                        <Outlet />
                      </MainLayout>
                    </ThemedLayoutV2>
                  </Authenticated>
                }
              >
                <Route index element={<RaceList />} />
                <Route path="races" element={<RaceList />} />
                <Route path="races/create" element={<RaceCreate />} />
                <Route path="races/show/:id" element={<RaceShow />} />
                <Route path="races/edit/:id" element={<RaceEdit />} />
              </Route>
              <Route
                element={
                  <ThemedLayoutV2
                    Title={() => <div>KYCレース管理</div>}
                  >
                    <Outlet />
                  </ThemedLayoutV2>
                }
              >
                <Route path="/login" element={<Login />} />
              </Route>
            </Routes>
          </Refine>
        </ConfigProvider>
      </RefineKbarProvider>
    </BrowserRouter>
  );
};

export default App;